module.exports = "\n<div class=\"cb-iframe\" id=\"cbFrame\"></div>"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/cart-iframe/cart-iframe.html
// module id = SV2/
// module chunks = 0